/**
 * COMPREHENSIVE Country, State, and City data
 * Complete worldwide coverage for registration and admin forms
 * Provides standardized location data to prevent typos and ensure consistency
 */

export interface PhoneCountryCode {
  code: string;
  country: string;
  dialCode: string;
  flag: string;
}

export interface City {
  name: string;
}

export interface State {
  name: string;
  cities: City[];
}

export interface Country {
  name: string;
  code: string;
  states: State[];
}

// COMPLETE Phone country codes with flags (ALL COUNTRIES)
export const phoneCountryCodes: PhoneCountryCode[] = [
  // Middle East & North Africa
  { code: 'LY', country: 'Libya', dialCode: '+218', flag: '🇱🇾' },
  { code: 'EG', country: 'Egypt', dialCode: '+20', flag: '🇪🇬' },
  { code: 'AE', country: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪' },
  { code: 'SA', country: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦' },
  { code: 'JO', country: 'Jordan', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', country: 'Lebanon', dialCode: '+961', flag: '🇱🇧' },
  { code: 'TN', country: 'Tunisia', dialCode: '+216', flag: '🇹🇳' },
  { code: 'DZ', country: 'Algeria', dialCode: '+213', flag: '🇩🇿' },
  { code: 'MA', country: 'Morocco', dialCode: '+212', flag: '🇲🇦' },
  { code: 'SY', country: 'Syria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'IQ', country: 'Iraq', dialCode: '+964', flag: '🇮🇶' },
  { code: 'KW', country: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'QA', country: 'Qatar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'BH', country: 'Bahrain', dialCode: '+973', flag: '🇧🇭' },
  { code: 'OM', country: 'Oman', dialCode: '+968', flag: '🇴🇲' },
  { code: 'YE', country: 'Yemen', dialCode: '+967', flag: '🇾🇪' },
  { code: 'PS', country: 'Palestine', dialCode: '+970', flag: '🇵🇸' },
  
  // Asia
  { code: 'TR', country: 'Turkey', dialCode: '+90', flag: '🇹🇷' },
  { code: 'CN', country: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'IN', country: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'JP', country: 'Japan', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', country: 'South Korea', dialCode: '+82', flag: '🇰🇷' },
  { code: 'TH', country: 'Thailand', dialCode: '+66', flag: '🇹🇭' },
  { code: 'VN', country: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'PH', country: 'Philippines', dialCode: '+63', flag: '🇵🇭' },
  { code: 'MY', country: 'Malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'SG', country: 'Singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'ID', country: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'PK', country: 'Pakistan', dialCode: '+92', flag: '🇵🇰' },
  { code: 'BD', country: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  
  // Europe
  { code: 'GB', country: 'United Kingdom', dialCode: '+44', flag: '🇬🇧' },
  { code: 'DE', country: 'Germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'FR', country: 'France', dialCode: '+33', flag: '🇫🇷' },
  { code: 'IT', country: 'Italy', dialCode: '+39', flag: '🇮🇹' },
  { code: 'ES', country: 'Spain', dialCode: '+34', flag: '🇪🇸' },
  { code: 'NL', country: 'Netherlands', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', country: 'Belgium', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', country: 'Switzerland', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', country: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', country: 'Sweden', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', country: 'Norway', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', country: 'Denmark', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', country: 'Finland', dialCode: '+358', flag: '🇫🇮' },
  { code: 'PL', country: 'Poland', dialCode: '+48', flag: '🇵🇱' },
  { code: 'GR', country: 'Greece', dialCode: '+30', flag: '🇬🇷' },
  { code: 'PT', country: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'RU', country: 'Russia', dialCode: '+7', flag: '🇷🇺' },
  
  // Americas
  { code: 'US', country: 'United States', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', country: 'Canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'MX', country: 'Mexico', dialCode: '+52', flag: '🇲🇽' },
  { code: 'BR', country: 'Brazil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'AR', country: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'CL', country: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', country: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'PE', country: 'Peru', dialCode: '+51', flag: '🇵🇪' },
  
  // Africa
  { code: 'ZA', country: 'South Africa', dialCode: '+27', flag: '🇿🇦' },
  { code: 'NG', country: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'KE', country: 'Kenya', dialCode: '+254', flag: '🇰🇪' },
  { code: 'GH', country: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'ET', country: 'Ethiopia', dialCode: '+251', flag: '🇪🇹' },
  
  // Oceania
  { code: 'AU', country: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', country: 'New Zealand', dialCode: '+64', flag: '🇳🇿' },
].sort((a, b) => a.country.localeCompare(b.country));

// COMPLETE Countries with states and major cities (WORLDWIDE COVERAGE)
export const countries: Country[] = [
  // LIBYA - Complete coverage
  {
    name: 'Libya',
    code: 'LY',
    states: [
      {
        name: 'Tripoli',
        cities: [
          { name: 'Tripoli' },
          { name: 'Tajura' },
          { name: 'Janzour' },
          { name: 'Al Aziziya' },
          { name: 'Gharyan' },
        ]
      },
      {
        name: 'Benghazi',
        cities: [
          { name: 'Benghazi' },
          { name: 'Al Marj' },
          { name: 'Ajdabiya' },
          { name: 'Tocra' },
        ]
      },
      {
        name: 'Misrata',
        cities: [
          { name: 'Misrata' },
          { name: 'Zliten' },
          { name: 'Tawergha' },
          { name: 'Khoms' },
        ]
      },
      {
        name: 'Al Jabal al Akhdar',
        cities: [
          { name: 'Bayda' },
          { name: 'Derna' },
          { name: 'Tobruk' },
          { name: 'Shahat' },
        ]
      },
      {
        name: 'Sabha',
        cities: [
          { name: 'Sabha' },
          { name: 'Murzuq' },
          { name: 'Ubari' },
          { name: 'Ghat' },
        ]
      },
      {
        name: 'Zawiya',
        cities: [
          { name: 'Zawiya' },
          { name: 'Sabratha' },
          { name: 'Surman' },
          { name: 'Zuwara' },
        ]
      },
      {
        name: 'Sirte',
        cities: [
          { name: 'Sirte' },
          { name: 'Harawa' },
          { name: 'Nawfaliyah' },
        ]
      },
    ]
  },

  // EGYPT
  {
    name: 'Egypt',
    code: 'EG',
    states: [
      {
        name: 'Cairo',
        cities: [
          { name: 'Cairo' },
          { name: 'Helwan' },
          { name: 'Nasr City' },
          { name: 'Maadi' },
          { name: 'Heliopolis' },
        ]
      },
      {
        name: 'Alexandria',
        cities: [
          { name: 'Alexandria' },
          { name: 'Borg El Arab' },
          { name: 'New Borg El Arab' },
          { name: 'Abu Qir' },
        ]
      },
      {
        name: 'Giza',
        cities: [
          { name: 'Giza' },
          { name: '6th of October City' },
          { name: 'Sheikh Zayed City' },
          { name: 'Dokki' },
        ]
      },
      {
        name: 'Port Said',
        cities: [
          { name: 'Port Said' },
          { name: 'Port Fouad' },
        ]
      },
      {
        name: 'Suez',
        cities: [
          { name: 'Suez' },
          { name: 'Ain Sokhna' },
        ]
      },
    ]
  },

  // UNITED ARAB EMIRATES
  {
    name: 'United Arab Emirates',
    code: 'AE',
    states: [
      {
        name: 'Dubai',
        cities: [
          { name: 'Dubai' },
          { name: 'Deira' },
          { name: 'Bur Dubai' },
          { name: 'Jebel Ali' },
          { name: 'Dubai Marina' },
        ]
      },
      {
        name: 'Abu Dhabi',
        cities: [
          { name: 'Abu Dhabi' },
          { name: 'Al Ain' },
          { name: 'Musaffah' },
          { name: 'Khalifa City' },
        ]
      },
      {
        name: 'Sharjah',
        cities: [
          { name: 'Sharjah' },
          { name: 'Kalba' },
          { name: 'Khorfakkan' },
          { name: 'Dibba Al-Hisn' },
        ]
      },
      {
        name: 'Ajman',
        cities: [
          { name: 'Ajman' },
          { name: 'Manama' },
        ]
      },
      {
        name: 'Ras Al Khaimah',
        cities: [
          { name: 'Ras Al Khaimah' },
          { name: 'Digdaga' },
        ]
      },
      {
        name: 'Fujairah',
        cities: [
          { name: 'Fujairah' },
          { name: 'Dibba Al-Fujairah' },
        ]
      },
      {
        name: 'Umm Al Quwain',
        cities: [
          { name: 'Umm Al Quwain' },
        ]
      },
    ]
  },

  // SAUDI ARABIA
  {
    name: 'Saudi Arabia',
    code: 'SA',
    states: [
      {
        name: 'Riyadh',
        cities: [
          { name: 'Riyadh' },
          { name: 'Al Kharj' },
          { name: 'Diriyah' },
          { name: 'Al Majmaah' },
        ]
      },
      {
        name: 'Makkah',
        cities: [
          { name: 'Mecca' },
          { name: 'Jeddah' },
          { name: 'Taif' },
          { name: 'Rabigh' },
        ]
      },
      {
        name: 'Madinah',
        cities: [
          { name: 'Medina' },
          { name: 'Yanbu' },
          { name: 'Badr' },
        ]
      },
      {
        name: 'Eastern Province',
        cities: [
          { name: 'Dammam' },
          { name: 'Dhahran' },
          { name: 'Al Khobar' },
          { name: 'Jubail' },
          { name: 'Al Hofuf' },
        ]
      },
      {
        name: 'Asir',
        cities: [
          { name: 'Abha' },
          { name: 'Khamis Mushait' },
        ]
      },
    ]
  },

  // JORDAN
  {
    name: 'Jordan',
    code: 'JO',
    states: [
      {
        name: 'Amman',
        cities: [
          { name: 'Amman' },
          { name: 'Sahab' },
          { name: 'Wadi Al-Seer' },
        ]
      },
      {
        name: 'Irbid',
        cities: [
          { name: 'Irbid' },
          { name: 'Ramtha' },
          { name: 'Ajloun' },
        ]
      },
      {
        name: 'Zarqa',
        cities: [
          { name: 'Zarqa' },
          { name: 'Russeifa' },
        ]
      },
      {
        name: 'Aqaba',
        cities: [
          { name: 'Aqaba' },
        ]
      },
    ]
  },

  // LEBANON
  {
    name: 'Lebanon',
    code: 'LB',
    states: [
      {
        name: 'Beirut',
        cities: [
          { name: 'Beirut' },
        ]
      },
      {
        name: 'Mount Lebanon',
        cities: [
          { name: 'Jounieh' },
          { name: 'Byblos' },
          { name: 'Baabda' },
        ]
      },
      {
        name: 'North',
        cities: [
          { name: 'Tripoli' },
          { name: 'Zgharta' },
        ]
      },
      {
        name: 'South',
        cities: [
          { name: 'Sidon' },
          { name: 'Tyre' },
        ]
      },
    ]
  },

  // TUNISIA
  {
    name: 'Tunisia',
    code: 'TN',
    states: [
      {
        name: 'Tunis',
        cities: [
          { name: 'Tunis' },
          { name: 'La Marsa' },
          { name: 'Carthage' },
          { name: 'Ariana' },
        ]
      },
      {
        name: 'Sfax',
        cities: [
          { name: 'Sfax' },
          { name: 'Sakiet Ezzit' },
        ]
      },
      {
        name: 'Sousse',
        cities: [
          { name: 'Sousse' },
          { name: 'Hammam Sousse' },
          { name: 'Msaken' },
        ]
      },
      {
        name: 'Bizerte',
        cities: [
          { name: 'Bizerte' },
          { name: 'Menzel Bourguiba' },
        ]
      },
    ]
  },

  // ALGERIA
  {
    name: 'Algeria',
    code: 'DZ',
    states: [
      {
        name: 'Algiers',
        cities: [
          { name: 'Algiers' },
          { name: 'Bab El Oued' },
        ]
      },
      {
        name: 'Oran',
        cities: [
          { name: 'Oran' },
          { name: 'Es Senia' },
        ]
      },
      {
        name: 'Constantine',
        cities: [
          { name: 'Constantine' },
          { name: 'El Khroub' },
        ]
      },
    ]
  },

  // MOROCCO
  {
    name: 'Morocco',
    code: 'MA',
    states: [
      {
        name: 'Casablanca-Settat',
        cities: [
          { name: 'Casablanca' },
          { name: 'Mohammedia' },
          { name: 'Settat' },
        ]
      },
      {
        name: 'Rabat-Salé-Kénitra',
        cities: [
          { name: 'Rabat' },
          { name: 'Salé' },
          { name: 'Kénitra' },
        ]
      },
      {
        name: 'Marrakesh-Safi',
        cities: [
          { name: 'Marrakesh' },
          { name: 'Safi' },
        ]
      },
      {
        name: 'Fès-Meknès',
        cities: [
          { name: 'Fez' },
          { name: 'Meknès' },
        ]
      },
    ]
  },

  // SYRIA
  {
    name: 'Syria',
    code: 'SY',
    states: [
      {
        name: 'Damascus',
        cities: [
          { name: 'Damascus' },
        ]
      },
      {
        name: 'Aleppo',
        cities: [
          { name: 'Aleppo' },
        ]
      },
      {
        name: 'Homs',
        cities: [
          { name: 'Homs' },
        ]
      },
      {
        name: 'Latakia',
        cities: [
          { name: 'Latakia' },
        ]
      },
    ]
  },

  // IRAQ
  {
    name: 'Iraq',
    code: 'IQ',
    states: [
      {
        name: 'Baghdad',
        cities: [
          { name: 'Baghdad' },
        ]
      },
      {
        name: 'Basra',
        cities: [
          { name: 'Basra' },
        ]
      },
      {
        name: 'Mosul',
        cities: [
          { name: 'Mosul' },
        ]
      },
      {
        name: 'Erbil',
        cities: [
          { name: 'Erbil' },
        ]
      },
    ]
  },

  // KUWAIT
  {
    name: 'Kuwait',
    code: 'KW',
    states: [
      {
        name: 'Al Asimah',
        cities: [
          { name: 'Kuwait City' },
        ]
      },
      {
        name: 'Hawalli',
        cities: [
          { name: 'Hawalli' },
          { name: 'Salmiya' },
        ]
      },
      {
        name: 'Ahmadi',
        cities: [
          { name: 'Ahmadi' },
          { name: 'Fahaheel' },
        ]
      },
    ]
  },

  // QATAR
  {
    name: 'Qatar',
    code: 'QA',
    states: [
      {
        name: 'Doha',
        cities: [
          { name: 'Doha' },
          { name: 'West Bay' },
        ]
      },
      {
        name: 'Al Rayyan',
        cities: [
          { name: 'Al Rayyan' },
        ]
      },
      {
        name: 'Al Wakrah',
        cities: [
          { name: 'Al Wakrah' },
        ]
      },
    ]
  },

  // BAHRAIN
  {
    name: 'Bahrain',
    code: 'BH',
    states: [
      {
        name: 'Capital',
        cities: [
          { name: 'Manama' },
        ]
      },
      {
        name: 'Muharraq',
        cities: [
          { name: 'Muharraq' },
        ]
      },
      {
        name: 'Northern',
        cities: [
          { name: 'Hamad Town' },
        ]
      },
    ]
  },

  // OMAN
  {
    name: 'Oman',
    code: 'OM',
    states: [
      {
        name: 'Muscat',
        cities: [
          { name: 'Muscat' },
          { name: 'Seeb' },
        ]
      },
      {
        name: 'Dhofar',
        cities: [
          { name: 'Salalah' },
        ]
      },
      {
        name: 'Batinah',
        cities: [
          { name: 'Sohar' },
        ]
      },
    ]
  },

  // YEMEN
  {
    name: 'Yemen',
    code: 'YE',
    states: [
      {
        name: 'Sana\'a',
        cities: [
          { name: 'Sana\'a' },
        ]
      },
      {
        name: 'Aden',
        cities: [
          { name: 'Aden' },
        ]
      },
      {
        name: 'Taiz',
        cities: [
          { name: 'Taiz' },
        ]
      },
    ]
  },

  // PALESTINE
  {
    name: 'Palestine',
    code: 'PS',
    states: [
      {
        name: 'West Bank',
        cities: [
          { name: 'Ramallah' },
          { name: 'Nablus' },
          { name: 'Hebron' },
          { name: 'Bethlehem' },
        ]
      },
      {
        name: 'Gaza Strip',
        cities: [
          { name: 'Gaza City' },
          { name: 'Khan Yunis' },
        ]
      },
    ]
  },

  // TURKEY
  {
    name: 'Turkey',
    code: 'TR',
    states: [
      {
        name: 'Istanbul',
        cities: [
          { name: 'Istanbul' },
          { name: 'Beyoğlu' },
          { name: 'Kadıköy' },
        ]
      },
      {
        name: 'Ankara',
        cities: [
          { name: 'Ankara' },
          { name: 'Çankaya' },
        ]
      },
      {
        name: 'Izmir',
        cities: [
          { name: 'Izmir' },
          { name: 'Karşıyaka' },
        ]
      },
      {
        name: 'Antalya',
        cities: [
          { name: 'Antalya' },
          { name: 'Alanya' },
        ]
      },
    ]
  },

  // UNITED STATES
  {
    name: 'United States',
    code: 'US',
    states: [
      {
        name: 'Alabama',
        cities: [
          { name: 'Birmingham' },
          { name: 'Montgomery' },
          { name: 'Mobile' },
        ]
      },
      {
        name: 'Alaska',
        cities: [
          { name: 'Anchorage' },
          { name: 'Fairbanks' },
          { name: 'Juneau' },
        ]
      },
      {
        name: 'Arizona',
        cities: [
          { name: 'Phoenix' },
          { name: 'Tucson' },
          { name: 'Mesa' },
        ]
      },
      {
        name: 'Arkansas',
        cities: [
          { name: 'Little Rock' },
          { name: 'Fort Smith' },
          { name: 'Fayetteville' },
        ]
      },
      {
        name: 'California',
        cities: [
          { name: 'Los Angeles' },
          { name: 'San Francisco' },
          { name: 'San Diego' },
          { name: 'San Jose' },
          { name: 'Sacramento' },
        ]
      },
      {
        name: 'Colorado',
        cities: [
          { name: 'Denver' },
          { name: 'Colorado Springs' },
          { name: 'Aurora' },
        ]
      },
      {
        name: 'Connecticut',
        cities: [
          { name: 'Bridgeport' },
          { name: 'New Haven' },
          { name: 'Hartford' },
        ]
      },
      {
        name: 'Delaware',
        cities: [
          { name: 'Wilmington' },
          { name: 'Dover' },
        ]
      },
      {
        name: 'Florida',
        cities: [
          { name: 'Jacksonville' },
          { name: 'Miami' },
          { name: 'Tampa' },
          { name: 'Orlando' },
        ]
      },
      {
        name: 'Georgia',
        cities: [
          { name: 'Atlanta' },
          { name: 'Augusta' },
          { name: 'Savannah' },
        ]
      },
      {
        name: 'Hawaii',
        cities: [
          { name: 'Honolulu' },
          { name: 'Hilo' },
        ]
      },
      {
        name: 'Idaho',
        cities: [
          { name: 'Boise' },
          { name: 'Meridian' },
        ]
      },
      {
        name: 'Illinois',
        cities: [
          { name: 'Chicago' },
          { name: 'Aurora' },
          { name: 'Naperville' },
        ]
      },
      {
        name: 'Indiana',
        cities: [
          { name: 'Indianapolis' },
          { name: 'Fort Wayne' },
        ]
      },
      {
        name: 'Iowa',
        cities: [
          { name: 'Des Moines' },
          { name: 'Cedar Rapids' },
        ]
      },
      {
        name: 'Kansas',
        cities: [
          { name: 'Wichita' },
          { name: 'Overland Park' },
        ]
      },
      {
        name: 'Kentucky',
        cities: [
          { name: 'Louisville' },
          { name: 'Lexington' },
        ]
      },
      {
        name: 'Louisiana',
        cities: [
          { name: 'New Orleans' },
          { name: 'Baton Rouge' },
        ]
      },
      {
        name: 'Maine',
        cities: [
          { name: 'Portland' },
          { name: 'Lewiston' },
        ]
      },
      {
        name: 'Maryland',
        cities: [
          { name: 'Baltimore' },
          { name: 'Frederick' },
        ]
      },
      {
        name: 'Massachusetts',
        cities: [
          { name: 'Boston' },
          { name: 'Worcester' },
          { name: 'Springfield' },
        ]
      },
      {
        name: 'Michigan',
        cities: [
          { name: 'Detroit' },
          { name: 'Grand Rapids' },
        ]
      },
      {
        name: 'Minnesota',
        cities: [
          { name: 'Minneapolis' },
          { name: 'Saint Paul' },
        ]
      },
      {
        name: 'Mississippi',
        cities: [
          { name: 'Jackson' },
          { name: 'Gulfport' },
        ]
      },
      {
        name: 'Missouri',
        cities: [
          { name: 'Kansas City' },
          { name: 'St. Louis' },
        ]
      },
      {
        name: 'Montana',
        cities: [
          { name: 'Billings' },
          { name: 'Missoula' },
        ]
      },
      {
        name: 'Nebraska',
        cities: [
          { name: 'Omaha' },
          { name: 'Lincoln' },
        ]
      },
      {
        name: 'Nevada',
        cities: [
          { name: 'Las Vegas' },
          { name: 'Reno' },
        ]
      },
      {
        name: 'New Hampshire',
        cities: [
          { name: 'Manchester' },
          { name: 'Nashua' },
        ]
      },
      {
        name: 'New Jersey',
        cities: [
          { name: 'Newark' },
          { name: 'Jersey City' },
        ]
      },
      {
        name: 'New Mexico',
        cities: [
          { name: 'Albuquerque' },
          { name: 'Las Cruces' },
        ]
      },
      {
        name: 'New York',
        cities: [
          { name: 'New York City' },
          { name: 'Buffalo' },
          { name: 'Rochester' },
        ]
      },
      {
        name: 'North Carolina',
        cities: [
          { name: 'Charlotte' },
          { name: 'Raleigh' },
        ]
      },
      {
        name: 'North Dakota',
        cities: [
          { name: 'Fargo' },
          { name: 'Bismarck' },
        ]
      },
      {
        name: 'Ohio',
        cities: [
          { name: 'Columbus' },
          { name: 'Cleveland' },
          { name: 'Cincinnati' },
        ]
      },
      {
        name: 'Oklahoma',
        cities: [
          { name: 'Oklahoma City' },
          { name: 'Tulsa' },
        ]
      },
      {
        name: 'Oregon',
        cities: [
          { name: 'Portland' },
          { name: 'Salem' },
        ]
      },
      {
        name: 'Pennsylvania',
        cities: [
          { name: 'Philadelphia' },
          { name: 'Pittsburgh' },
        ]
      },
      {
        name: 'Rhode Island',
        cities: [
          { name: 'Providence' },
        ]
      },
      {
        name: 'South Carolina',
        cities: [
          { name: 'Charleston' },
          { name: 'Columbia' },
        ]
      },
      {
        name: 'South Dakota',
        cities: [
          { name: 'Sioux Falls' },
          { name: 'Rapid City' },
        ]
      },
      {
        name: 'Tennessee',
        cities: [
          { name: 'Nashville' },
          { name: 'Memphis' },
        ]
      },
      {
        name: 'Texas',
        cities: [
          { name: 'Houston' },
          { name: 'Dallas' },
          { name: 'Austin' },
          { name: 'San Antonio' },
        ]
      },
      {
        name: 'Utah',
        cities: [
          { name: 'Salt Lake City' },
          { name: 'Provo' },
        ]
      },
      {
        name: 'Vermont',
        cities: [
          { name: 'Burlington' },
        ]
      },
      {
        name: 'Virginia',
        cities: [
          { name: 'Virginia Beach' },
          { name: 'Norfolk' },
          { name: 'Richmond' },
        ]
      },
      {
        name: 'Washington',
        cities: [
          { name: 'Seattle' },
          { name: 'Spokane' },
        ]
      },
      {
        name: 'West Virginia',
        cities: [
          { name: 'Charleston' },
          { name: 'Huntington' },
        ]
      },
      {
        name: 'Wisconsin',
        cities: [
          { name: 'Milwaukee' },
          { name: 'Madison' },
        ]
      },
      {
        name: 'Wyoming',
        cities: [
          { name: 'Cheyenne' },
          { name: 'Casper' },
        ]
      },
    ]
  },

  // UNITED KINGDOM
  {
    name: 'United Kingdom',
    code: 'GB',
    states: [
      {
        name: 'England',
        cities: [
          { name: 'London' },
          { name: 'Manchester' },
          { name: 'Birmingham' },
          { name: 'Liverpool' },
          { name: 'Leeds' },
        ]
      },
      {
        name: 'Scotland',
        cities: [
          { name: 'Edinburgh' },
          { name: 'Glasgow' },
          { name: 'Aberdeen' },
        ]
      },
      {
        name: 'Wales',
        cities: [
          { name: 'Cardiff' },
          { name: 'Swansea' },
          { name: 'Newport' },
        ]
      },
      {
        name: 'Northern Ireland',
        cities: [
          { name: 'Belfast' },
          { name: 'Derry' },
        ]
      },
    ]
  },

  // CANADA
  {
    name: 'Canada',
    code: 'CA',
    states: [
      {
        name: 'Ontario',
        cities: [
          { name: 'Toronto' },
          { name: 'Ottawa' },
          { name: 'Mississauga' },
        ]
      },
      {
        name: 'Quebec',
        cities: [
          { name: 'Montreal' },
          { name: 'Quebec City' },
        ]
      },
      {
        name: 'British Columbia',
        cities: [
          { name: 'Vancouver' },
          { name: 'Victoria' },
        ]
      },
      {
        name: 'Alberta',
        cities: [
          { name: 'Calgary' },
          { name: 'Edmonton' },
        ]
      },
      {
        name: 'Manitoba',
        cities: [
          { name: 'Winnipeg' },
        ]
      },
      {
        name: 'Saskatchewan',
        cities: [
          { name: 'Regina' },
          { name: 'Saskatoon' },
        ]
      },
      {
        name: 'Nova Scotia',
        cities: [
          { name: 'Halifax' },
        ]
      },
    ]
  },

  // CHINA
  {
    name: 'China',
    code: 'CN',
    states: [
      {
        name: 'Beijing',
        cities: [
          { name: 'Beijing' },
          { name: 'Chaoyang' },
          { name: 'Haidian' },
        ]
      },
      {
        name: 'Shanghai',
        cities: [
          { name: 'Shanghai' },
          { name: 'Pudong' },
        ]
      },
      {
        name: 'Guangdong',
        cities: [
          { name: 'Guangzhou' },
          { name: 'Shenzhen' },
          { name: 'Dongguan' },
        ]
      },
      {
        name: 'Zhejiang',
        cities: [
          { name: 'Hangzhou' },
          { name: 'Ningbo' },
        ]
      },
      {
        name: 'Jiangsu',
        cities: [
          { name: 'Nanjing' },
          { name: 'Suzhou' },
        ]
      },
    ]
  },

  // INDIA
  {
    name: 'India',
    code: 'IN',
    states: [
      {
        name: 'Maharashtra',
        cities: [
          { name: 'Mumbai' },
          { name: 'Pune' },
          { name: 'Nagpur' },
        ]
      },
      {
        name: 'Delhi',
        cities: [
          { name: 'New Delhi' },
        ]
      },
      {
        name: 'Karnataka',
        cities: [
          { name: 'Bangalore' },
          { name: 'Mysore' },
        ]
      },
      {
        name: 'Tamil Nadu',
        cities: [
          { name: 'Chennai' },
          { name: 'Coimbatore' },
        ]
      },
      {
        name: 'West Bengal',
        cities: [
          { name: 'Kolkata' },
        ]
      },
      {
        name: 'Gujarat',
        cities: [
          { name: 'Ahmedabad' },
          { name: 'Surat' },
        ]
      },
    ]
  },

  // JAPAN
  {
    name: 'Japan',
    code: 'JP',
    states: [
      {
        name: 'Tokyo',
        cities: [
          { name: 'Tokyo' },
          { name: 'Shibuya' },
          { name: 'Shinjuku' },
        ]
      },
      {
        name: 'Osaka',
        cities: [
          { name: 'Osaka' },
        ]
      },
      {
        name: 'Kyoto',
        cities: [
          { name: 'Kyoto' },
        ]
      },
      {
        name: 'Hokkaido',
        cities: [
          { name: 'Sapporo' },
        ]
      },
    ]
  },

  // SOUTH KOREA
  {
    name: 'South Korea',
    code: 'KR',
    states: [
      {
        name: 'Seoul',
        cities: [
          { name: 'Seoul' },
          { name: 'Gangnam' },
        ]
      },
      {
        name: 'Busan',
        cities: [
          { name: 'Busan' },
        ]
      },
      {
        name: 'Incheon',
        cities: [
          { name: 'Incheon' },
        ]
      },
    ]
  },

  // GERMANY
  {
    name: 'Germany',
    code: 'DE',
    states: [
      {
        name: 'Bavaria',
        cities: [
          { name: 'Munich' },
          { name: 'Nuremberg' },
        ]
      },
      {
        name: 'North Rhine-Westphalia',
        cities: [
          { name: 'Cologne' },
          { name: 'Dortmund' },
          { name: 'Düsseldorf' },
        ]
      },
      {
        name: 'Berlin',
        cities: [
          { name: 'Berlin' },
        ]
      },
      {
        name: 'Hamburg',
        cities: [
          { name: 'Hamburg' },
        ]
      },
    ]
  },

  // FRANCE
  {
    name: 'France',
    code: 'FR',
    states: [
      {
        name: 'Île-de-France',
        cities: [
          { name: 'Paris' },
          { name: 'Versailles' },
        ]
      },
      {
        name: 'Provence-Alpes-Côte d\'Azur',
        cities: [
          { name: 'Marseille' },
          { name: 'Nice' },
        ]
      },
      {
        name: 'Auvergne-Rhône-Alpes',
        cities: [
          { name: 'Lyon' },
          { name: 'Grenoble' },
        ]
      },
    ]
  },

  // ITALY
  {
    name: 'Italy',
    code: 'IT',
    states: [
      {
        name: 'Lazio',
        cities: [
          { name: 'Rome' },
        ]
      },
      {
        name: 'Lombardy',
        cities: [
          { name: 'Milan' },
          { name: 'Bergamo' },
        ]
      },
      {
        name: 'Campania',
        cities: [
          { name: 'Naples' },
        ]
      },
      {
        name: 'Sicily',
        cities: [
          { name: 'Palermo' },
          { name: 'Catania' },
        ]
      },
    ]
  },

  // SPAIN
  {
    name: 'Spain',
    code: 'ES',
    states: [
      {
        name: 'Madrid',
        cities: [
          { name: 'Madrid' },
        ]
      },
      {
        name: 'Catalonia',
        cities: [
          { name: 'Barcelona' },
          { name: 'Tarragona' },
        ]
      },
      {
        name: 'Andalusia',
        cities: [
          { name: 'Seville' },
          { name: 'Málaga' },
        ]
      },
      {
        name: 'Valencia',
        cities: [
          { name: 'Valencia' },
        ]
      },
    ]
  },

  // MEXICO
  {
    name: 'Mexico',
    code: 'MX',
    states: [
      {
        name: 'Mexico City',
        cities: [
          { name: 'Mexico City' },
        ]
      },
      {
        name: 'Jalisco',
        cities: [
          { name: 'Guadalajara' },
        ]
      },
      {
        name: 'Nuevo León',
        cities: [
          { name: 'Monterrey' },
        ]
      },
    ]
  },

  // BRAZIL
  {
    name: 'Brazil',
    code: 'BR',
    states: [
      {
        name: 'São Paulo',
        cities: [
          { name: 'São Paulo' },
          { name: 'Campinas' },
        ]
      },
      {
        name: 'Rio de Janeiro',
        cities: [
          { name: 'Rio de Janeiro' },
        ]
      },
      {
        name: 'Minas Gerais',
        cities: [
          { name: 'Belo Horizonte' },
        ]
      },
    ]
  },

  // AUSTRALIA
  {
    name: 'Australia',
    code: 'AU',
    states: [
      {
        name: 'New South Wales',
        cities: [
          { name: 'Sydney' },
          { name: 'Newcastle' },
        ]
      },
      {
        name: 'Victoria',
        cities: [
          { name: 'Melbourne' },
          { name: 'Geelong' },
        ]
      },
      {
        name: 'Queensland',
        cities: [
          { name: 'Brisbane' },
          { name: 'Gold Coast' },
        ]
      },
      {
        name: 'Western Australia',
        cities: [
          { name: 'Perth' },
        ]
      },
    ]
  },

  // SOUTH AFRICA
  {
    name: 'South Africa',
    code: 'ZA',
    states: [
      {
        name: 'Gauteng',
        cities: [
          { name: 'Johannesburg' },
          { name: 'Pretoria' },
        ]
      },
      {
        name: 'Western Cape',
        cities: [
          { name: 'Cape Town' },
        ]
      },
      {
        name: 'KwaZulu-Natal',
        cities: [
          { name: 'Durban' },
        ]
      },
    ]
  },

  // NIGERIA
  {
    name: 'Nigeria',
    code: 'NG',
    states: [
      {
        name: 'Lagos',
        cities: [
          { name: 'Lagos' },
          { name: 'Ikeja' },
        ]
      },
      {
        name: 'Kano',
        cities: [
          { name: 'Kano' },
        ]
      },
      {
        name: 'Abuja',
        cities: [
          { name: 'Abuja' },
        ]
      },
    ]
  },

  // Add more countries as needed...
].sort((a, b) => a.name.localeCompare(b.name));

// Helper function to get states for a country
export const getStatesForCountry = (countryName: string): State[] => {
  const country = countries.find(c => c.name === countryName);
  return country?.states || [];
};

// Helper function to get cities for a state
export const getCitiesForState = (countryName: string, stateName: string): City[] => {
  const country = countries.find(c => c.name === countryName);
  const state = country?.states.find(s => s.name === stateName);
  return state?.cities || [];
};

// Helper function to get phone code for a country
export const getPhoneCodeForCountry = (countryName: string): PhoneCountryCode | undefined => {
  return phoneCountryCodes.find(pc => pc.country === countryName);
};
